import { Box, BoxProps, Skeleton, Typography } from '@mui/material';
import { deepmerge } from '@mui/utils';

type Props = BoxProps & {
  title: string;
  subtitle?: string;
  withPadding?: boolean;
};

export const TableHeaderSkeleton = ({ title, subtitle, withPadding, sx, ...rest }: Props) => {
  return (
    <Box {...rest} sx={withPadding ? deepmerge({ p: 2 }, sx) : sx}>
      <Skeleton>
        <Typography variant="h5" sx={{ fontWeight: 400, color: 'transparent' }}>
          {title}
        </Typography>
      </Skeleton>
      {subtitle && (
        <Typography variant="subtitle1" sx={{ fontWeight: 400, fontSize: '0.875rem', color: 'transparent' }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};
